import React from 'react';
import Modal from './Modal';
import FormsySimpleInput from '../form/FormsySimpleInput';
import Select from '../form/Select';
import countryRegion from '../../countryRegion.js';
import Formsy from 'formsy-react';
import { clientAPI } from '../../InterfaceAPI/clientAPI';
import CreditCardInput from 'react-credit-card-input';
import withSplashMessage from '../splashMessage/withSplashMessage';
import { stringfyServerErrors } from '../../helpers/util';

class PaymentModal extends React.Component {
  defaultPayment = {
    card_type: '',
    cc_number: '',
    cvc: '',
    expiration_date: '',
    address: '',
    city: '',
    country: 'United States',
    state: '',
    zip_code: ''
  };

  state = {
    payment: {
      ...this.defaultPayment
    },
    isLoading: true,
    isValid: false,
    countryRegionData: [],
    stateOptions: []
  };

  render() {
    const { addressIndex } = this.props;

    return (
      <Modal
        isOpen={this.props.isOpen}
        onRequestClose={this.props.closeModal}
        className="modal modal--no-padding admin-wrapper"
      >
        <div className="modal__head">
          <h2 className="h2 modal__heading">
            {addressIndex >= 0 ? 'Edit Payment' : 'New Payment'}
          </h2>
          {this.state.isLoading ? 'Loading...' : this.renderForm()}
        </div>
      </Modal>
    );
  }

  renderForm() {
    const {
      cc_number,
      cvc,
      expiration_date,
      address,
      city,
      state,
      country,
      zip_code
    } = this.state.payment;
    const { closeModal } = this.props;

    return (
      <Formsy
        className="form"
        onValidSubmit={this.submit}
        onValid={this.handleValid}
        onInvalid={this.handleInvalid}
      >
        <div className="form-group">
          <h1 className="form-group__h1">Credit Card Information</h1>
          <div className="form__row">
            <CreditCardInput
              cardNumberInputProps={{
                value: cc_number,
                name: 'cc_number',
                onChange: this.handleChange
              }}
              cardExpiryInputProps={{
                value: expiration_date,
                name: 'expiration_date',
                onChange: this.handleChange
              }}
              cardCVCInputProps={{
                value: cvc,
                name: 'cvc',
                onChange: this.handleChange
              }}
              dangerTextClassName="cc-input--invalid"
              fieldClassName="cc-input"
            />

            <FormsySimpleInput
              type="hidden"
              name="cc_number"
              placeholder=""
              value={cc_number || ''}
              required
            />
            <FormsySimpleInput
              type="hidden"
              name="expiration_date"
              placeholder=""
              value={expiration_date || ''}
              required
            />
            <FormsySimpleInput
              type="hidden"
              name="cvc"
              placeholder="CVC"
              value={cvc || ''}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <h1 className="form-group__h1">Billing Address</h1>
          <div className="form__row">
            <div className="form__row-item form__row-item--full">
              <p className="simple-input__label">Address Line</p>
              <FormsySimpleInput
                type="text"
                name="address"
                placeholder=""
                value={address || ''}
                onChange={this.handleChange}
                required
              />
            </div>
          </div>
          <div className="form__row">
            <div className="form__row-item form__row-item--half">
              <p className="simple-input__label">City</p>
              <FormsySimpleInput
                type="text"
                name="city"
                placeholder=""
                value={city || ''}
                onChange={this.handleChange}
                required
              />
            </div>
            <div className="form__row-item form__row-item--half">
              <p className="simple-input__label">Country</p>
              <Select
                name="country"
                value={country || ''}
                options={this.getCountryOptions()}
                onChange={this.handleCountrySelectChange}
                required
              />
            </div>
          </div>

          <div className="form__row">
            <div className="form__row-item form__row-item--half">
              <p className="simple-input__label">State</p>
              <Select
                name="state"
                value={state || ''}
                options={this.getStateOptions(this.state.countryRegionData)}
                onChange={this.handleStateSelectChange}
                required
              />
            </div>
            <div className="form__row-item form__row-item--half">
              <p className="simple-input__label">Zip / Postal Code</p>
              <FormsySimpleInput
                type="text"
                name="zip_code"
                placeholder=""
                value={zip_code || ''}
                onChange={this.handleChange}
                required
              />
            </div>
          </div>
        </div>

        <div className="form__row">
          <div className="form__row-item--half">
            <div
              className="btn btn--hollow-blue btn--full-width"
              onClick={closeModal}
            >
              Nevermind
            </div>
          </div>
          <div className="form__row-item--half">
            <input
              type="submit"
              className="btn btn--solid-blue btn--full-width"
              value="Update Now"
              disabled={!this.state.isValid}
            />
          </div>
        </div>
      </Formsy>
    );
  }

  submit = () => {
    const payment = this.mutatePayload(this.state.payment);
    clientAPI
      .updateClientPaymentProfile(this.props.client.id, { payment })
      .then(res => {
        this.props.closeModal();
        this.props.addMessage({
          className: 'success',
          message: 'Payment Method Updated'
        });
      })
      .catch(err =>
        this.props.addMessage({
          className: 'error',
          message: stringfyServerErrors(err)
        })
      );
  };

  handleCountrySelectChange = opt => {
    const payment = {
      ...this.state.payment,
      country: opt ? opt.value : ''
    };
    this.setState({ payment });
  };

  handleStateSelectChange = opt => {
    const payment = {
      ...this.state.payment,
      state: opt ? opt.value : ''
    };
    this.setState({ payment });
  };

  handleChange = e => {
    const { name, value } = e.target;
    const payment = {
      ...this.state.payment,
      [name]: value
    };
    this.setState({ payment });
  };

  handleValid = () => this.setState({ isValid: true });
  handleInvalid = () => this.setState({ isValid: false });

  loadPayment() {
    if (this.props.client.id) {
      this.setState({ isLoading: true });
      clientAPI
        .getClientPaymentProfile(this.props.client.id)
        .then(({ payment }) =>
          this.setState({
            payment: this.ingestPayload(payment),
            isLoading: false
          })
        )
        .catch(err => {
          this.setState({ payment: this.defaultPayment, isLoading: false });

          console.log(err);
        });
    }
  }

  getCountryOptions() {
    const data = this.state.countryRegionData;
    return data.map(country => {
      return {
        value: country.countryName,
        label: country.countryName
      };
    });
  }

  getStateOptions() {
    const data = this.state.countryRegionData;
    const country = this.state.payment.country;
    return country
      ? data
          .filter(
            nation =>
              nation.countryName === country ||
              nation.countryShortCode === country
          )[0]
          .regions.map(region => {
            return {
              value: region.name,
              label: region.name
            };
          })
      : [];
  }

  componentDidMount() {
    this.setState({ countryRegionData: countryRegion });
  }

  componentDidUpdate(prevProps) {
    // update state from props
    if (this.props.isOpen && this.props.isOpen !== prevProps.isOpen) {
      this.loadPayment();
    }
  }

  mutatePayload = payment => {
    const dates = payment.expiration_date.split(' / ');
    const expiration_date = `20${dates[1]}-${dates[0]}`;
    const cc_number = payment.cc_number.replace(/\s/g, '');
    const cvc = parseInt(payment.cvc, 10);

    return { ...payment, expiration_date, cc_number, cvc };
  };

  ingestPayload = payment => {
    const dates = payment.expiration_date.split('-');
    const expiration_date = `${dates[1]} / ${dates[0].slice(-2)}`;

    return { ...payment, expiration_date };
  };
}

export default withSplashMessage(PaymentModal);



// WEBPACK FOOTER //
// ./src/components/shared/PaymentModal.js